import React from "react";
import { motion } from "framer-motion";

const TestimonialSection = () => {
  // Image inside the blob
  const kidsImageUrl =
    "https://res.cloudinary.com/ddvpczzng/image/upload/v1757497484/1_g72rfh.png";

  // Background image
  const bgImageUrl =
    "https://www.counsellinginmelbourne.com.au/wp-content/uploads/2023/03/The-Importance-of-Play-for-Child-Development-small.jpg";

  return (
    <section
      className="relative w-screen left-1/2 right-1/2 mx-[-50vw] overflow-hidden 
      -mt-12 md:-mt-16 lg:-mt-20 
      mb-[-48px] md:mb-[-64px] lg:mb-[-80px] 
      pt-16 md:pt-20 lg:pt-24 
      pb-16 md:pb-20 lg:pb-24"
      style={{
        backgroundImage: `url(${bgImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      aria-labelledby="testimonial-heading"
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" aria-hidden="true"></div>

      {/* Content Wrapper */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Visually hidden heading to name the section for a11y/SEO */}
        <h2 id="testimonial-heading" className="sr-only">
          Student Experience and Environment
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="
            flex flex-col lg:flex-row items-center 
            gap-8 lg:gap-12 
            w-full 
            border-2 border-yellow-300 
            rounded-3xl shadow-xl 
            bg-white/20 backdrop-blur-sm 
            p-6 sm:p-8 lg:p-10
          "
        >
          {/* Left Side - Image with Blob */}
          <motion.div
            whileHover={{ scale: 1.03 }}
            className="
              relative 
              w-48 h-48 sm:w-56 sm:h-56 lg:w-64 lg:h-64 
              group flex-shrink-0
            "
          >
            <svg
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute w-full h-full -z-10"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="#facc15"
                d="M47.4,-65.6C60.4,-55.6,68.8,-39.5,72.8,-22.6C76.7,-5.7,76.1,11.9,68.5,25.5C61,39.1,46.5,48.6,31.4,58.6C16.3,68.6,0.7,79.1,-13.5,76.4C-27.6,73.7,-40.3,57.8,-51.1,43C-61.8,28.2,-70.6,14.1,-70.3,-0.4C-70.1,-14.9,-60.8,-29.8,-48.8,-39.5C-36.9,-49.2,-22.4,-53.8,-7.4,-60.6C7.5,-67.5,15,-76.5,27.6,-77.1C40.3,-77.7,53.7,-69.8,47.4,-65.6Z"
                transform="translate(100 100)"
              />
            </svg>
            <img
              src={kidsImageUrl}
              alt="Students practicing Silambam at STVMHS"
              loading="lazy"
              width="600"
              height="600"
              className="
                w-full h-full object-cover 
                rounded-2xl shadow-xl 
                ring-4 ring-yellow-200 
                transition duration-300 
                group-hover:ring-yellow-300
              "
              decoding="async"
            />
          </motion.div>

          {/* Right Side - Message */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="
              relative 
              bg-white 
              px-6 py-8 sm:px-8 sm:py-10 
              rounded-3xl shadow-lg w-full 
              transition-all duration-300 
              hover:shadow-yellow-200/50
            "
          >
            {/* Opening Quote - now inside the card */}
            <span
              className="absolute top-4 left-4 text-6xl text-yellow-400 font-serif"
              aria-hidden="true"
            >
              “
            </span>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 sm:mb-4 text-gray-900">
              At <span className="text-amber-600">STVMHS</span>,
            </h2>
            <div className="space-y-3 sm:space-y-4">
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed sm:leading-loose">
                every child begins a joyful journey of learning and discovery.
              </p>
              <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed sm:leading-loose">
                We believe space shapes learning. Our colorful, kid-friendly
                environment encourages joy, creativity, and confidence in every
                step.
              </p>
            </div>

            {/* Closing Quote */}
            <span
              className="absolute -bottom-6 right-4 text-6xl text-yellow-400 font-serif"
              aria-hidden="true"
            >
              ”
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialSection;
